import { Linked } from '@type-r/react';
import * as React from 'react';
import { InvoiceModel } from 'api/invoice';
import { InvoiceDialog } from './invoiceDialog';

export const ApproveInvoiceDialog = (props : {
    $isOpen : Linked<boolean>,
    invoice : InvoiceModel,
    disputedInvoice : InvoiceModel,
    prevInvoice : InvoiceModel
}) =>
    <InvoiceDialog
        {...props}
        dialogType="approve"
    />
